import {IRootModel} from "@/shared/models/abstract/IRootModel";

export class PropertyChangedArgs {
    constructor(public propertyName: string, public model: IRootModel) {
    }
}
